<template>
  <div class="layout-center">
		<div class="header">
			<img class="header-bg" src="@/assets/data-center/layout-center-header.png" >
			<div class="header-content">
				<div class="data-item">
					<div class="data-item-value">1,514,124.34</div>
					<div class="data-item-name">营业额</div>
				</div>
				<div class="line"></div>
				<div class="data-item">
					<div class="data-item-value">625,145</div>
					<div class="data-item-name">总订单</div>
				</div>
				<div class="line"></div>
				<div class="data-item">
					<div class="data-item-value">125,451.05</div>
					<div class="data-item-name">充电金额</div>
				</div>
				<div class="line"></div>
				<div class="data-item">
					<div class="data-item-value">15,243</div>
					<div class="data-item-name">总电量</div>
				</div>
				<div class="line"></div>
				<div class="data-item">
					<div class="data-item-value">51,243</div>
					<div class="data-item-name">用户数</div>
				</div>
			</div>
		</div>
		<div class="map-box">
			<!-- <img class="map-img" src="@/assets/data-center/map.png" /> -->
			<!-- <div id="china-map" class="map-img"></div> -->
			<div ref="chart" class="map-img"></div>
		</div>
	</div>
</template>

<script>
import * as echarts from "echarts"
import TitleBar from './title-bar.vue'
import axios from 'axios'

export default {
	components: { TitleBar },

	mounted() {
		this.loadChinaMap()
  },

  methods: {
		async loadChinaMap() {
      try {
        const res = await axios.get("/map/china.json") // 读取 GeoJSON 数据
				console.log('地图', res.data)
				let geoJson = res.data
				// geoJson.features = geoJson.features.filter(
				// 	feature => feature.properties.name !== ""
				// )
        echarts.registerMap("china", geoJson) // 注册中国地图
        this.initChart()
      } catch (error) {
        console.error("地图数据加载失败", error)
      }
    },
		initChart() {
      this.chart = echarts.init(this.$refs.chart)

      const option = {
        backgroundColor: "#090909", // 黑色背景
        geo: {
          map: "china",
          roam: true, // 是否可以缩放
					zoom: 1.6, // 初始缩放比例
					aspectScale: 1, // 宽高比
					center: [105.4, 34.9],
          label: { show: false },
          itemStyle: {
            normal: {
              areaColor: "#0077FF", // 地图颜色
              borderColor: "#fff", // 省份边界颜色
            },
            emphasis: {
							areaColor: "#00aaff",
							label: { color: '#fff' }
						 } // 悬停颜色
          }
        },
        series: [
          {
            name: "设备状态",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: [
              { name: "广州", value: [113.264385, 23.12911, 50] },
              { name: "深圳", value: [114.057868, 22.543099, 30] },
              { name: "长沙", value: [112.982279, 28.19409, 20] }
            ],
            rippleEffect: {
              period: 2, // 波动速度
              scale: 3, // 波动范围
              brushType: "stroke" // 波纹描边
            },
            label: {
              show: true,
              formatter: "{b}",
              position: "right",
              color: "#fff"
            },
            itemStyle: { color: "#FF4500" },
            symbolSize: 15
          }
        ]
      }

      this.chart.setOption(option)
    },
  },
}
</script>

<style lang="scss" scoped>
.layout-center {
	flex: 1;
	margin: 0 36px;
	.header {
		width: 100%;
		height: 109px;
		position: relative;
		.header-bg {
			width: 100%;
			height: 100%;
			position: absolute;
			left: 0;
			top: 0;
		}
		.header-content {
			height: 100%;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
			.line {
				width: 1px;
				height: 50px;
				background-color: rgba(255, 255, 255, .1);
				margin: 0 24px;
			}
			.data-item {
				.data-item-value {
					color: #009DFF;
					font-size: 28px;
					font-weight: bold;
				}
				.data-item-name {
					margin-top: 8px;
					color: #fff;
					font-size: 16px;
					font-weight: bold;
					text-align: center;
				}
			}
		}
	}
	.map-box {
		width: 855px;
		height: 520px;
		margin: 41px auto 0;
		.map-img {
			width: 100%;
			height: 100%;
		}
	}
}

</style>
